export function getTenderValue (tender) {
  const latestVersion = tender.tenderVersions[0];

  const sumOfBids = latestVersion.lots.reduce(
    (p, c) => p + (c.bid?.totalPrice ?? 0),
    0
  );
  const sumOfEstimatedLotValues = latestVersion.lots.reduce(
    (p, c) => p + (c.estimatedPrice ?? 0),
    0
  );

  if (latestVersion.sumOfTotalLotPrice > 10 || sumOfBids > 10) {
    return {
      field: 'sumOfTotalLotPrice',
      value: Math.max(
        latestVersion.sumOfTotalLotPrice ?? 0,
        sumOfBids
      )
    };
  }

  if (
    latestVersion.sumOfEstimatedLotValues > 10 ||
          sumOfEstimatedLotValues > 10
  ) {
    return {
      field: 'sumOfEstimatedLotValues',
      value: Math.max(
        latestVersion.sumOfEstimatedLotValues ?? 0,
        sumOfEstimatedLotValues
      )
    };
  }

  if (latestVersion.value > 10) {
    return {
      field: 'value',
      value: latestVersion.value
    };
  }

  if (latestVersion.estimatedValue > 10) {
    return {
      field: 'estimatedValue',
      value: latestVersion.estimatedValue
    };
  }

  return {
    field: null,
    value: null
  };
}

export function getLotValue(tender, lot) {
  const latestVersion = tender.tenderVersions[0];

  if (lot.bid?.totalPrice > 10) {
    return {
      field: "lot.bid.totalPrice",
      value: lot.bid.totalPrice,
    };
  }

  if (lot.estimatedPrice > 10) {
    return {
      field: "lot.estimatedPrice",
      value: lot.estimatedPrice,
    };
  }

  if (latestVersion.value > 10) {
    return {
      field: "value",
      value: latestVersion.value,
    };
  }

  if (latestVersion.estimatedValue > 10) {
    return {
      field: "estimatedValue",
      value: latestVersion.estimatedValue,
    };
  }


  return {
    field: null,
    value: null
  }
}
